import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const CreateCoupon = lazy(() => import('../../container/coupon/CreateCoupon'));
const CouponsTable = lazy(() => import('../../container/coupon/CouponsTable'));

function CouponRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/create/new`} component={CreateCoupon} />
      <Route path={`${path}/overview`} component={CouponsTable} />
    </Switch>
  );
}

export default CouponRoutes;
